/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  arrayOf,
  string,
  shape,
  func,
  bool,
} from 'prop-types';
import _ from 'lodash';
import {
  Heading,
  Paragraph,
  Label,
  LazyLoadImg,
} from 'components/common';
import {
  FaqContextualPanel,
  questionWithQuestionMark,
} from 'components/FAQ/FaqContextualContainer';
import withApplicationConfig from 'containers/withApplicationConfig';
import RewardSlickPanel from 'pages/Verticals/ProductPage/RewardSlickPanel';
import { onCtaClick } from 'helpers/Utils';

import CountDown from 'components/common/CountDown';
import './OffersSectionTW.scss';

const getProviderOffersLabel = (label, provider) => {
  const template = _.template(label);
  return (provider) ? template({ provider }) : label;
};

const OffersSection = (
  {
    exclusiveOffers = [],
    welcomeOffers = [],
    faqs = {},
    labels = {},
    provider = {},
    onCtaLinkClick = null,
    ctaButton = null,
    productName = null,
    countdownFormat,
    promotional,
  }
) => (
  <div className="tw-offers-section">
    <div className="container-wrapper">
      <div className="row-wrapper">
        <div className="title">
          <div>
            <Heading as="h2">
              {labels.heading}
            </Heading>
          </div>
        </div>
        <div className="content">
          <div className="row-wrapper">
            <div className="offers-column-wrapper">
              {_.isArray(exclusiveOffers) && exclusiveOffers.length > 0 && (
                <div className="reward-column">
                  <div className="exclusive-title">
                    <Label exclusive inlineSpacing>
                      {labels.exclusive}
                    </Label>
                    {
                      promotional?.countdown?.displayProductPage
                      && promotional?.date?.endDate
                      && (
                        <Label timeLimitedCount inlineSpacing>
                          <CountDown
                            // eslint-disable-next-line react/no-array-index-key
                            key="TIME_LIMITED_COUNT"
                            name={promotional?.countdown?.text}
                            toTime={promotional?.date?.endDate}
                            timeOffset={countdownFormat?.timeOffset}
                            loadingText={labels.loadingText}
                            endText={labels.endText}
                            displayFormat={countdownFormat?.displayFormat}
                            maxUnit={countdownFormat?.maxUnit}
                            variant="secondary"
                            weight="semiBold"
                          />
                        </Label>
                      )
                    }
                  </div>
                  <div className="exclusive-title">
                    <Paragraph>
                      <strong>
                        {labels.exclusiveOffers}
                      </strong>
                    </Paragraph>
                  </div>
                  <div className="exclusive-slick-with-banner">
                    <div className="reward-slick-panel-wrapper">
                      <RewardSlickPanel
                        rewards={exclusiveOffers}
                        labelOption={labels.optionLabel}
                      />
                    </div>
                    {promotional?.productPageBanner?.enableBanner
                    && promotional?.productPageBanner?.imageForDesktop?.url
                    && (
                      <div className="exclusive-content" onClick={onCtaClick(ctaButton, onCtaLinkClick)}>
                        <LazyLoadImg
                          alt={productName}
                          src={promotional?.productPageBanner?.imageForDesktop?.url || ''}
                          className="exclusive-image"
                          lazy
                        />
                      </div>
                    )}
                    {promotional?.productPageBanner?.enableBanner
                    && promotional?.productPageBanner?.imageForMobile?.url
                    && (
                      <div className="exclusive-content mobile" onClick={onCtaClick(ctaButton, onCtaLinkClick)}>
                        <LazyLoadImg
                          alt={productName}
                          src={promotional?.productPageBanner?.imageForMobile?.url || ''}
                          className="exclusive-image"
                          lazy
                        />
                      </div>
                    )}
                    {!promotional?.productPageBanner?.enableBanner
                    && faqs
                    && (
                      <div className="exclusive-content">
                        <FaqContextualPanel
                          sidebar
                          questionRender={questionWithQuestionMark}
                          {...faqs}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              {_.isArray(welcomeOffers) && welcomeOffers.length > 0 && (
                <div className="reward-column">
                  <Paragraph>
                    <strong>
                      {getProviderOffersLabel(labels.welcomeOffers, provider)}
                    </strong>
                  </Paragraph>
                  <div className="reward-slick-panel-wrapper without-banner">
                    <RewardSlickPanel
                      rewards={welcomeOffers}
                      labelOption={labels.optionLabel}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

OffersSection.defaultProps = {
  exclusiveOffers: [],
  welcomeOffers: [],
  labels: {},
  provider: {},
  faqs: null,
  onCtaLinkClick: null,
  ctaButton: null,
  productName: null,
  countdownFormat: {},
  promotional: {},
};

OffersSection.propTypes = {
  exclusiveOffers: arrayOf(shape({})),
  welcomeOffers: arrayOf(shape({})),
  faqs: shape({}),
  labels: shape({
    heading: string,
    exclusiveOffers: string,
    welcomeOffers: string,
    exclusive: string,
  }),
  provider: shape({
    name: string,
  }),
  onCtaLinkClick: func,
  ctaButton: shape({
    show: bool,
    label: string.isRequired,
    link: shape({
      url: string.isRequired,
    }),
  }),
  productName: string,
  countdownFormat: shape({}),
  promotional: shape({}),
};

export default withApplicationConfig(OffersSection, ['productPane']);
